import StatusChip, { ChipType } from 'components/@extended/StatusChip';
import { useCallback } from 'react';
import { ClassifierData } from 'types/classifiers';
import { getClassifierText } from 'utils/getTranslations';

export interface MatterAssignmentsStatusLabelProps {
    endDate: string | null | undefined;
    classifier: ClassifierData;
}

export const AssignementStatusLabel = ({ endDate, classifier }: MatterAssignmentsStatusLabelProps): JSX.Element => {
    const hasEndDatePassed = endDate ? new Date(endDate).getTime() : null;
    const currentTime = new Date().getTime();
    const statusCode =
        hasEndDatePassed === null || undefined || hasEndDatePassed > currentTime ? 'In Progress' : 'Completed';

    const getLabel = useCallback(() => getClassifierText(classifier, statusCode), [statusCode, classifier]);

    return <StatusChip type={getAssignmenttatusChipType(statusCode)} label={getLabel()} />;
};

const getAssignmenttatusChipType = (statusTypeCode: string): ChipType => {
    const chipTypes: Record<string, ChipType> = {
        'In Progress': 'success',
        Completed: 'neutral',
    };

    return chipTypes[statusTypeCode] || 'outlined';
};
